import * as React from "react";

export const SvgDirection = ({ "data-testid": dataTestId = null, ...props }) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" data-testid={dataTestId} {...props}>
		<mask
			id="a"
			style={{
				maskType: "luminance",
			}}
			maskUnits="userSpaceOnUse"
			x={0}
			y={0}
			width={20}
			height={20}
		>
			<path d="M.5.5h19v19H.5V.5Z" fill="#fff" />
		</mask>
		<g
			mask="url(#a)"
			stroke={props.color ?? "#A8A8A8"}
			strokeWidth={1.5}
			strokeMiterlimit={10}
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path d="M9.463 10.537 18.05 1.95M9.464 10.537 2.724 8.61a1.065 1.065 0 0 1-.773-1.024v0c0-.479.314-.9.772-1.038L18.05 1.95l-4.598 15.326c-.137.458-.559.772-1.037.772h0c-.476 0-.894-.315-1.025-.773l-1.925-6.74Z" />
		</g>
	</svg>
);
